// extracted by mini-css-extract-plugin
module.exports = {"accordionContent":"styles_accordionContent__iKCmN","btn":"styles_btn__U_etB"};